import { render } from "./TrainingCourse.vue?vue&type=template&id=ee13f106"
import script from "./TrainingCourse.vue?vue&type=script&lang=js"
export * from "./TrainingCourse.vue?vue&type=script&lang=js"

import "./TrainingCourse.vue?vue&type=style&index=0&id=ee13f106&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__